import React, { useContext, useMemo } from "react";
import { Divider, Grid, Typography } from "@material-ui/core";
import { isEmpty } from "lodash";
import CloseIcon from "@material-ui/icons/Close";
import { UserListContext } from "../../../../../../context/follow-up-widgets";
import { usePublish } from "../../../../../../hooks/publisher-subscriber";
import Config from "../../domain/config";
import { getProfileAvatarByGender } from "../../../../../../utils";
import AddFollowUpCommentView from "./components/add-follow-up-comment-view/follow-up-view";

const SideView = () => {
  const { currentSideView } = useContext(UserListContext);
  const publish = usePublish();

  const { advertisement } = currentSideView;

  const computedAdValues = useMemo(() => {
    const output = {
      avatar: "",
      fullName: "",
      age: "",
      profession: "",
    };
    if (isEmpty(advertisement)) {
      return output;
    }

    output.avatar = getProfileAvatarByGender(advertisement.post.gender);
    output.fullName = `${advertisement.post.firstName} ${advertisement.post.lastName}`;
    output.age = advertisement.post.age;
    output.profession = advertisement.post.profession.name;

    return output;
  }, [advertisement]);

  return (
    <Grid
      item
      container
      xs
      direction="column"
      className="follow-up-widget-side-view"
    >
      <Grid container direction="column" className="gap-y-16 p-16">
        <CloseIcon
          onClick={() => {
            publish("closeSideView");
          }}
          className="cursor-pointer"
          style={{ marginLeft: "auto" }}
        />

        <Grid container style={{ columnGap: 16 }}>
          <img
            src={computedAdValues.avatar}
            alt=""
            width={50}
            height={50}
            className="avatar"
          />
          <Grid container xs direction="column">
            <Typography variant="h5">{computedAdValues.fullName}</Typography>
            <Typography variant="body2">
              {`${computedAdValues.age} • ${computedAdValues.profession}`}
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      <Divider />

      <Grid container direction="column" className="p-16">
        {currentSideView.currentView ===
          Config.SIDE_VIEW_VARAIENT.addFollowUpComment && <AddFollowUpCommentView />}
      </Grid>
    </Grid>
  );
};

export default SideView;
